import styled, { css } from "styled-components";
import { Flex, SearchField as UISearchField } from "@evergis/ui";

import { Control } from "../../styled";
import { HeaderPrefix } from "../../../Table/styled";

export const LayersListSearchResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: calc(100% - 4rem);
`;

export const SearchField = styled(UISearchField)`
  background: white;

  :disabled {
    border: 0;
  }
`;

export const FoundTitleContainer = styled.div`
  padding: 0.25rem 1.5rem 0.75rem;
  display: flex;
  align-items: center;
`;

export const FoundTitle = styled.div`
  font-size: 1rem;
  margin-right: 0.5rem;
`;

export const FoundCount = styled.div`
  font-size: 1rem;
  opacity: 0.54;
`;

export const Tag = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  height: 0.75rem;
  margin: 0 0.75rem 0 0.5rem;
  padding: 0.125rem 0.375rem;
  background: rgba(0, 0, 0, 0.12);
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.medium};
  font-size: 10px;
  color: rgba(0, 0, 0, 0.87);
`;

export const LayerControls = styled(Control)`
  align-items: center;
  margin-right: -0.25rem;
`;

export const FeaturesSearchResultList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem 1rem;
`;

export const FeatureSearchResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.75rem 1.75rem;
`;

export const FeatureName = styled.div`
  font-size: 14px;
  cursor: pointer;
  color: ${({ theme: { palette } }) => palette.primary};

  &:hover {
    text-decoration: underline;
  }
`;

export const FeatureAttribute = styled.div`
  font-size: 0.75rem;
  opacity: 0.54;
`;

export const FeatureAttributeInfo = styled(Flex)`
  align-items: center;

  ${HeaderPrefix} {
    margin-right: 0.25rem;
  }
`;

export const LoadMore = styled.div`
  margin-top: 1rem;
  font-size: 10px;
  cursor: pointer;
  color: ${({ theme: { palette } }) => palette.primary};

  &:hover {
    text-decoration: underline;
  }
`;

export const LayerName = styled.div`
  width: 100%;
  min-width: 1px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

export const ProgressContainer = styled(Flex)`
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const AttributeSeparator = styled.div`
  width: 0.25rem;
  height: 0.25rem;
  margin: 0 0.5rem 0 0.5rem;
  border-radius: 50%;
  background-color: ${({ theme: { palette } }) => palette.elementDeep};
`;

export const SearchMenuContainer = styled.div`
  margin: 0.5rem 0;
`;

export const LayerSearchResultsContainer = styled.div<{ isTaskExecuting?: boolean }>`
  flex: 1;
  box-sizing: border-box;
  padding: 0 1.5rem 0 0.75rem;

  ${({ isTaskExecuting }) =>
    !isTaskExecuting
      ? css`
          // Влияет на рендер результатов во время выполнения таски
          overflow-x: hidden;
          overflow-y: auto;
        `
      : ""}
`;
